import { useLayoutEffect, useRef, type MutableRefObject } from 'react';

/**
 * Ref that always holds the latest value. Lets stable callbacks read the
 * current props/closures without being re-created on every render.
 */
export function useLatest<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
